import Timeline from '../../../components/Timeline';
import { Component } from 'react';
import { module1Keys } from './keys';
import { colors } from '../../../lib/colors';
import { withTranslation } from 'react-i18next';

class PositionModule1 extends Component {
    constructor() {
        super();
    }

    render() {
        const { t } = this.props;

        const chartData = (datasetIndex) => ({
            labels: this.props.data?.map((item) => item.position),
            datasets: module1Keys(t).map((item, i) => ({
                label: item?.label,
                type: item.type ?? 'line',
                data: this.props.data?.map((data) =>
                    item.render ? item.render(data[item.key]) : data[item.key],
                ),
                backgroundColor: [colors[i], colors[i]],
                borderColor:
                    datasetIndex === null || datasetIndex === i
                        ? colors[i]
                        : 'rgba(128, 128, 128, 0.2)',
                yAxisID: item.yAxisID ?? 'y',
                hidden: item.hidden ?? false,
                borderRadius: 4,
                tension: 0.4,
            })),
        });

        return (
            <Timeline
                chartSize="lg"
                metricType="primary"
                data={this.props.data}
                error={this.props.error}
                header={t('search.ctr_per_position.module_1.header')}
                keys={module1Keys(t)}
                parent_id={this.props.parent_id}
                content_id={this.props.content_id}
                chartData={chartData}
                hasRightAxis
                forceRun={this.props.forceRun}
                leftAxisLabel={t('global.ctr_per')}
                rightAxisLabel={t('global.keywords')}
                xAxisTitle={t('global.position')}
                hasLeftSecondAxis
                leftSecondAxisLabel={t('global.clicks')}
            />
        );
    }
}

export default withTranslation()(PositionModule1);
